// This is just an example,
// so you can safely delete all default props below

export default {
  failed: 'Action failed',
  success: 'Action was successful',
  index: {
    operation: "Manuale d'uso",
    app_store: 'Autorizzazione commerciale',
    signin: 'Indirizzo di accesso:',
    app_title: "titolo dell'app",
    slogan: 'Slogan',
    server: "richiedi l'url di base",
    index_title: 'Piattaforma di gestione del magazzino',
    webtitle: 'GreaterWMS--Sistema di gestione del magazzino open source',
    home: 'prima pagina',
    title: 'GreaterWMS',
    title_tip: 'Homepage GreaterWMS',
    hide_menu: 'Chiudi menu',
    api: 'Documentazione API',
    translate: 'Cambia lingua',
    unread: 'Messaggi non letti',
    login: 'Accedere',
    register: 'Registrati',
    login_tip: 'Inserisci il tuo OPENID e nome utente',
    register_tip: 'Registrati come amministratore',
    logout: 'Disconnettersi',
    user_login: 'Login utente',
    admin_login: 'Accesso amministratore',
    return_to_login: 'torna al login',
    user_center: 'Centro utenti',
    change_user: 'Cambia utente',
    view_my_openid: 'Visualizza il mio OPENID',
    your_openid: 'il tuo OPENID',
    contact_list: 'Contatti recenti',
    chat_more: 'Altre notizie storiche',
    chat_no_more: 'Niente più notizie',
    chat_send: 'Inviare',
    previous: 'Pagina precedente',
    next: 'Pagina successiva',
    admin_name: 'amministratore',
    password: "'parola d'ordine'",
    confirm_password: 'Conferma password',
    staff_name: 'nome utente',
    cancel: 'Annulla',
    close: 'chiusura',
    submit: 'Invia',
    download: 'Scarica',
    updatetitle: 'Aggiornamento pronto',
    updatedesc: "La versione è pronta per l'aggiornamento",
    update: 'Aggiorna ora',
    chart: 'Rapporto',
    current_user: 'Utente corrente'
  },
  Settings: {
    index: 'Impostazioni',
    server: 'Server',
    equipment: 'Supporto per attrezzature'
  },
  menuItem: {
    dashboard: 'Dashboard',
    inbound: 'In entrata',
    outbound: 'In uscita',
    stock: 'inventario',
    finance: 'Finanza',
    goods: 'Elenco merci',
    baseinfo: 'Informazioni di base',
    warehouse: 'Magazzino',
    staff: 'Personale',
    driver: 'Autista',
    customerdn: 'DN cliente',
    supplierasn: 'Fornitore ASN',
    uploadcenter: 'Centro di caricamento',
    downloadcenter: 'Centro download',
    cloudwarehouse: 'Interconnessione dei magazzini'
  },
  contact: 'Comunicare immediatamente',
  sendmessage: 'Inviagli un messaggio',
  send: 'Inviare',
  nomoremessage: 'Niente più notizie',
  loadmore: 'caricare di più',
  new: 'Aggiungere',
  newtip: 'Aggiungi nuovi dati',
  refresh: 'ricaricare',
  refreshtip: 'Aggiorna tutti i dati',
  edit: 'Modifica questi dati',
  confirmedit: 'Conferma dati di modifica',
  canceledit: 'Annulla modifica dati',
  delete: 'Elimina questi dati',
  deletetip: 'Questa operazione è irreversibile. ',
  confirmdelete: 'Conferma eliminazione dati',
  canceldelete: 'Annulla eliminazione dati',
  download: 'Scarica',
  downloadtip: 'Scarica tutti i dati',
  frombin: 'Dalla posizione di archiviazione',
  movetobin: 'Trasferimento',
  putaway: 'sul ripiano',
  cyclecount: 'Inventario dinamico',
  cyclecountrecorder: 'Registro di inventario',
  search: 'Ricerca per parola chiave',
  creater: 'fondatore',
  createtime: 'creare tempo',
  updatetime: 'Tempo di aggiornamento',
  action: 'operare',
  previous: 'Pagina precedente',
  next: 'Pagina successiva',
  no_data: 'Niente più dati',
  submit: 'Confermare',
  cancel: 'Annulla',
  estimate: 'Consegna prevista',
  downloadasnlist: 'Scarica elenco',
  downloadasndetail: 'Scarica dettagli',
  downloadasnlisttip: 'Scarica la lista degli avvisi di arrivo',
  downloadasndetailtip: "'Scarica i dettagli dell'notice di arrivo'",
  printthisasn: "'Controlla l'notice di arrivo'",
  confirmdelivery: 'È arrivata la conferma',
  finishloading: 'Conferma ordinamento completato',
  confirmsorted: 'Conferma ordinamento completato',
  downloaddnlist: 'Scarica elenco',
  downloaddndetail: 'Scarica dettagli',
  downloaddnlisttip: 'Scarica elenco fatture',
  downloaddndetailtip: 'Scarica i dettagli della fattura',
  release: 'ordine di corrispondenza',
  releaseallorder: 'Tutti genera elenco di selezione',
  releaseorder: 'Genera elenco di selezione',
  print: 'Stampa lista di prelievo',
  printthisdn: 'Visualizza e stampa fatture',
  confirmorder: "'Confermare l'ordine'",
  confirmpicked: 'Conferma prelievo completato',
  dispatch: 'Carico e consegna',
  deletebackorder: 'Elimina ordine arretrato',
  confirminventoryresults: 'Conferma il risultato del conteggio',
  baseinfo: {
    company_info: "'informazioni sull'azienda'",
    supplier: 'fornitore',
    customer: 'cliente',
    view_company: {
      company_name: 'Nome della ditta',
      company_city: 'Posizione città',
      company_address: 'indirizzo',
      company_contact: 'Informazioni sui contatti',
      company_manager: 'principale',
      error1: "'Inserisci il nome dell'azienda'",
      error2: "'Inserisci la città in cui si trova l'azienda'",
      error3: "'Inserisci l'indirizzo dell'azienda'",
      error4: "'Inserisci il contatto dell'azienda'",
      error5: "'Inserisci il responsabile dell'azienda'"
    },
    view_supplier: {
      supplier_name: 'Nome del fornitore',
      supplier_city: 'Posizione città',
      supplier_address: 'indirizzo',
      supplier_contact: 'Informazioni sui contatti',
      supplier_manager: 'principale',
      supplier_level: 'Livello fornitore',
      error1: 'Inserisci il nome del fornitore',
      error2: 'Inserisci la città in cui si trova il fornitore',
      error3: "'Inserisci l'indirizzo del fornitore'",
      error4: 'Inserisci le informazioni di contatto',
      error5: 'Inserisci il responsabile del fornitore',
      error6: 'Inserisci il livello del fornitore'
    },
    view_customer: {
      customer_name: 'nome del cliente',
      customer_city: 'Posizione città',
      customer_address: 'indirizzo',
      customer_contact: 'Informazioni sui contatti',
      customer_manager: 'principale',
      customer_level: 'Livello cliente',
      error1: 'Inserisci il nome del cliente',
      error2: 'Inserisci la città in cui si trova il cliente',
      error3: "'Inserisci l'indirizzo del cliente'",
      error4: 'Inserisci un contatto',
      error5: 'Inserisci account manager',
      error6: 'Inserisci il livello cliente'
    }
  },
  dashboards: {
    outbound_statements: 'Rapporto in uscita',
    inbound_statements: 'Rapporto di ricezione',
    inbound_and_outbound_statements: 'Rapporto di ricezione e consegna',
    total_sales: 'Vendite totali',
    category_sales_ranking: 'Classifica delle vendite di categoria',
    sales_volume_ranking: 'Rank vendite',
    sales_volumes_ranking: 'Numero di classifica delle vendite',
    total_receipts: 'Incarico totale',
    category_receipt_ranking: 'Classifica delle ricevute di categoria',
    receiving_quantity_ranking: 'Classifica quantità ricevuta',
    Receiving_amount_ranking: 'Classifica delle ricevute',
    view_tradelist: {
      mode_code: 'mezzo di transazione',
      bin_name: 'Nome del luogo',
      goods_code: 'Codice merce',
      goods_qty: 'Quantità a portata di mano',
      creater: 'fondatore',
      update_time: 'Tempo di aggiornamento',
      create_time: 'creare tempo',
      inbound: 'Ricevuta',
      outbound: 'Nave'
    }
  },
  finance: {
    capital: 'Immobilizzazioni',
    freight: 'Gestione merci',
    view_capital: {
      capital_name: 'Nome della risorsa fissa',
      capital_qty: 'quantità',
      capital_cost: 'Quantità',
      error1: 'Inserisci il nome della risorsa',
      error2: 'Il numero di asset deve essere maggiore di 0',
      error3: "'L'importo dell'asset deve essere maggiore di 0'"
    },
    view_freight: {
      transportation_supplier: 'Vettore',
      send_city: 'Città originaria',
      receiver_city: 'città di arrivo',
      weight_fee: 'Spedizione al chilo',
      volume_fee: 'Spedizione di un metro cubo',
      min_payment: 'Spedizione minima',
      error1: 'Inserisci un vettore',
      error2: 'Inserisci la città di invio',
      error3: 'Inserisci la città di destinazione',
      error4: 'Il costo di spedizione per chilogrammo deve essere maggiore di 0',
      error5: 'Il costo di spedizione di un metro cubo deve essere maggiore di 0',
      error6: 'La spedizione minima deve essere maggiore di 0'
    }
  },
  driver: {
    driver: 'Gestione dei conducenti',
    dispatchlist: 'Registro di ritiro',
    error1: 'Inserisci il nome del conducente',
    error2: 'Inserisci il numero di targa',
    error3: 'Inserisci un contatto',
    view_driver: {
      driver_name: 'nome del conducente',
      license_plate: 'targa',
      contact: 'Informazioni sui contatti'
    },
    view_dispatch: {
      driver_name: 'nome del conducente',
      dn_code: "'Numero d'ordine di ritiro'",
      contact: 'Informazioni sui contatti'
    }
  },
  upload_center: {
    initializeupload: 'Inizia caricamento',
    uploadfiles: 'caricare files',
    upload: 'caricamento',
    uploadcustomerfile: 'Carica elenco clienti',
    uploadgoodslistfile: 'Carica elenco moduli prodotto',
    uploadsupplierfile: 'Carica elenco fornitori',
    downloadgoodstemplate: 'Scarica modello prodotto',
    downloadcustomertemplate: 'Scarica modello cliente',
    downloadsuppliertemplate: 'Scarica modello fornitore',
    addupload: 'Aggiungi caricamento'
  },
  download_center: {
    createTime: 'creare tempo',
    reset: 'Ripristina',
    start: 'Inizio',
    end: 'Fine'
  },
  community_mall: {
    communitymall: 'Centro commerciale comunitario'
  },
  goods: {
    goods_list: 'Elenco prodotti',
    unit: 'Unità merceologica',
    class: 'Categoria articolo',
    color: 'colore del prodotto',
    brand: 'marchio del prodotto',
    shape: 'Forma del prodotto',
    specs: 'Specifiche del prodotto',
    origin: 'Origine del prodotto',
    view_goodslist: {
      goods_code: 'Codice merce',
      goods_desc: 'Descrizione del prodotto',
      goods_name: 'nome del prodotto',
      goods_supplier: 'fornitore',
      goods_weight: 'Peso della merce (unità: grammi)',
      goods_w: 'Lunghezza articolo (unità: mm)',
      goods_d: 'Larghezza del prodotto (unità: mm)',
      goods_h: 'Altezza merce (unità: mm)',
      unit_volume: "'Volume minimo dell'unità'",
      goods_unit: 'Unità merceologica',
      goods_class: 'Categoria articolo',
      goods_brand: 'marchio del prodotto',
      goods_color: 'colore del prodotto',
      goods_shape: 'Forma del prodotto',
      goods_specs: 'Specifiche del prodotto',
      goods_origin: 'Origine del prodotto',
      goods_cost: 'Costo delle merci',
      goods_price: 'Prezzo delle merci',
      print_goods_label: 'Stampa etichetta prodotto',
      error1: 'Inserisci il codice prodotto',
      error2: 'Inserisci la descrizione del prodotto',
      error3: 'Inserisci il fornitore del prodotto',
      error4: "'Il peso dell'articolo deve essere maggiore di 0'",
      error5: "'La lunghezza dell'oggetto deve essere maggiore di 0'",
      error6: 'La larghezza del prodotto deve essere maggiore di 0',
      error7: "'L'altezza del prodotto deve essere maggiore di 0'",
      error8: 'Inserisci il costo della merce',
      error9: 'Inserisci il prezzo del prodotto'
    },
    view_unit: {
      goods_unit: 'Unità merceologica',
      error1: 'Inserisci unità di prodotto'
    },
    view_class: {
      goods_class: 'Categoria articolo',
      error1: 'Inserisci la categoria del prodotto'
    },
    view_color: {
      goods_color: 'colore del prodotto',
      error1: 'Inserisci il colore del prodotto'
    },
    view_brand: {
      goods_brand: 'marchio del prodotto',
      error1: 'Inserisci la marca del prodotto'
    },
    view_shape: {
      goods_shape: 'Forma del prodotto',
      error1: 'Inserisci la forma del prodotto'
    },
    view_specs: {
      goods_specs: 'Specifiche del prodotto',
      error1: 'Inserisci le specifiche del prodotto'
    },
    view_origin: {
      goods_origin: 'Origine del prodotto',
      error1: "'Inserisci l'origine del prodotto'"
    }
  },
  inbound: {
    asn: 'notice di arrivo',
    predeliverystock: 'arrivare',
    preloadstock: 'Da scaricare',
    presortstock: 'da ordinare',
    sortstock: 'smistato',
    shortage: 'A corto di merce in entrata',
    more: 'Altri arrivi',
    asnfinish: 'Dettagli ricevuta',
    asndone: 'Ricevuta completata',
    view_sortstock: {
      error1: 'Inserisci la quantità, la quantità deve essere maggiore di 0'
    },
    view_asn: {
      asn_code: 'Numero notice di arrivo',
      asn_status: 'Stato notifica di arrivo',
      goods_qty: 'Numero di avvisi di arrivo',
      goods_actual_qty: 'Quantità di arrivo effettiva',
      goods_shortage_qty: 'Arrivato in breve quantità',
      goods_more_qty: 'Grande quantità in arrivo',
      goods_damage_qty: 'Numero di arrivi danneggiati',
      presortstock: 'Numero da ordinare',
      sorted_qty: 'Quantità in magazzino',
      total_weight: 'Peso totale (unità: kg)',
      total_volume: 'Volume totale (unità: metro cubo)'
    }
  },
  outbound: {
    dn: 'Fattura',
    freshorder: 'Pre-fattura',
    neworder: 'Nuova fattura',
    backorder: 'Ordini arretrati',
    pickstock: 'da scegliere',
    pickedstock: 'Scelto',
    pickinglist: 'Dettagli elenco di selezione',
    shippedstock: 'Spedito',
    received: 'Sono stati ricevuti',
    pod: 'Firma la ricevuta',
    view_dn: {
      dn_code: 'numero di spedizione',
      dn_status: 'Stato fattura',
      goods_qty: 'quantità di ordine',
      intransit_qty: 'Quantità spedita',
      delivery_actual_qty: 'Quantità di arrivo effettiva',
      delivery_shortage_qty: 'Breve arrivo',
      delivery_more_qty: 'Altri arrivi',
      delivery_damage_qty: 'Arrivato danneggiato',
      total_weight: 'Peso totale (unità: kg)',
      total_volume: 'Volume totale (unità: metro cubo)',
      customer: 'cliente'
    }
  },
  staff: {
    staff: 'Elenco dipendenti',
    check_code: 'Codice di verifica',
    view_staff: {
      staff_name: 'Nome dipendente',
      staff_type: 'tipo di dipendente',
      error1: 'Inserisci il nome del dipendente',
      error2: 'Inserisci il tipo di dipendente',
      lock: 'blocco',
      unlock: 'sbloccare'
    }
  },
  stock: {
    stocklist: 'lista di azioni',
    stockbinlist: 'Elenco località',
    emptybin: 'Posizione vuota',
    occupiedbin: 'Posizione in magazzino',
    view_stocklist: {
      goods_code: 'Codice merce',
      goods_desc: 'Descrizione del prodotto',
      goods_qty: "'L'ammontare totale'",
      onhand_stock: 'Quantità a portata di mano',
      can_order_stock: 'Quantità che può essere collocata',
      ordered_stock: 'Numero di ordini effettuati',
      inspect_stock: "'Quantità dell'ispezione di qualità'",
      hold_stock: 'Quantità bloccata',
      damage_stock: 'Quantità pausa',
      asn_stock: 'Numero di avvisi di arrivo',
      dn_stock: 'Quantità fattura',
      pre_load_stock: 'Quantità da scaricare',
      pre_sort_stock: 'Numero da ordinare',
      sorted_stock: 'Numero ordinato',
      pick_stock: 'Quantità da prelevare',
      picked_stock: 'Quantità raccolta',
      back_order_stock: 'Importo delle merci dovute',
      on_hand_inventory: 'scorte esistenti',
      history_inventory: 'Disponibile al momento',
      physical_inventory: 'Conta quantità',
      difference: 'differenza',
      cyclecount: 'Inventario dinamico',
      recyclecount: 'Ripristina',
      downloadcyclecount: 'Inventario',
      cyclecountresult: 'verifica risultati',
      cyclecounttip: 'Genera tabella inventario dinamica',
      recyclecounttip: 'Genera checklist di rifornimento',
      downloadcyclecounttip: 'Scarica lista di controllo',
      cyclecountresulttip: 'Conferma il risultato del conteggio',
      daychoice: 'Selezione data',
      daychoicetip: "'Seleziona la tabella dell'inventario corrispondente alla data'",
      error1: 'Il numero di conteggi deve essere maggiore di 0',
      dateerror: 'Data selezionata errata'
    }
  },
  warehouse: {
    warehouse: 'Impostazioni magazzino',
    binset: 'Impostazione posizione magazzino',
    binsize: 'Dimensione delle scorte',
    property: 'Posizione proprietà',
    printbin: 'Stampa etichetta posizione',
    view_warehouseset: {
      error1: 'Inserisci il nome del magazzino',
      error2: 'Inserisci la città in cui si trova il magazzino',
      error3: "'Inserisci l'indirizzo del magazzino'",
      error4: 'Inserisci le informazioni di contatto del magazzino',
      error5: 'Inserisci il responsabile del magazzino'
    },
    view_warehouse: {
      warehouse_name: 'nome magazzino',
      warehouse_city: 'Posizione città',
      warehouse_address: 'indirizzo',
      warehouse_contact: 'Informazioni sui contatti',
      warehouse_manager: 'principale',
      square_measure: 'Area utile',
      city_search: 'Ricerca città',
      publish_warehouse: 'Pubblica magazzino',
      Nopublish_warehouse: 'Deposito di richiamo'
    },
    view_binset: {
      bin_name: 'Nome del luogo',
      bin_size: 'Dimensione delle scorte',
      bin_property: 'Posizione proprietà',
      empty_label: 'ID posizione vuoto',
      error1: 'Inserisci il nome della località',
      error2: 'Inserisci la dimensione della posizione',
      error3: "Inserisci l'attributo della località"
    },
    view_binsize: {
      bin_size: 'Dimensione delle scorte',
      bin_size_w: 'Lunghezza stock (unità: mm)',
      bin_size_d: 'Larghezza stock (unità: mm)',
      bin_size_h: 'Altezza stock (unità: mm)',
      error1: 'Inserisci la dimensione della posizione',
      error2: 'La lunghezza del percorso di archiviazione deve essere maggiore di 0',
      error3: 'La larghezza dello stock deve essere maggiore di 0',
      error4: 'La larghezza dello stock deve essere maggiore di 0'
    },
    view_property: {
      bin_property: 'Proprietà posizione magazzino'
    }
  },
  scan: {
    scan: 'scansione',
    scan_asn: 'Richiesta ASN',
    scan_dn: 'Richiesta DN',
    scan_sorting: 'ordinamento',
    scan_uptobin: 'sul ripiano',
    scan_picking: 'raccogliere',
    scan_shipping: 'Carico e consegna',
    scan_movetobin: 'Trasferimento',
    scan_inventory: 'inventario',
    scan_goodsquery: 'Richiesta di carico',
    scan_locationquery: 'Richiesta posizione magazzino',
    scan_goods_code: 'Codice merce',
    scan_bin_name: 'Nome del luogo',
    scan_goods_label: 'Etichetta del prodotto',
    scan_goods_label_error: "'L'etichetta dell'articolo non esiste'",
    view_binmove: {
      old_bin_name: 'Nome località originale',
      new_bin_name: 'Nuovo nome posizione',
      qty: 'Numero di magazzini spostati',
      qty_error: 'La quantità da movimentare non deve essere superiore alla quantità esistente'
    },
    view_upToBin: {
      goods_actual_qty: 'Quantità di arrivo effettiva',
      scan_qty: 'Numero di scansioni',
      scan_qty_error: 'Il numero di scansioni non deve essere maggiore del numero di arrivi'
    },
    view_picking: {
      order_qty: 'quantità di ordine',
      picking_qty: 'Numero di scelte',
      picking_qty_error: "'La quantità del prelievo non deve essere superiore alla quantità dell'ordine'"
    },
    view_shipping: {
      shipping_code: 'numero di spedizione',
      driver_info: 'informazioni sul conducente',
      license_plate_number: 'targa',
      name: 'Nome',
      contact_info: 'Informazioni sui contatti'
    }
  },
  handcount: {
    handcount: 'Conteggio unico',
    handcountrecorder: 'Registratore a conteggio singolo',
    update_time: 'Conta il tempo'
  },
  notice: {
    valerror: 'Inserisci il valore corretto',
    unknow_error: 'errore sconosciuto',
    network_error: 'anomalia di rete',
    nullerror: '',
    cyclecounterror: 'nessun dato',
    userererror: 'Il nome utente esiste già',
    capitalerror: 'Il nome della risorsa fissa esiste già',
    valuenullerror: 'Si prega di compilare i dati completi',
    loginerror: 'per favore fai prima il log in',
    goodserror: {
      goods_listerror: 'Il codice merce esiste già',
      goods_uniterror: 'Unità merceologica già esistente',
      goods_classerror: 'Categoria articolo esiste già',
      goods_colorerror: "'Il colore dell'articolo esiste già'",
      goods_branderror: 'Il marchio delle materie prime esiste già',
      goods_shapeerror: "'La forma dell'oggetto esiste già'",
      goods_specserror: 'La specifica del prodotto esiste già',
      goods_originerror: "L'origine del prodotto esiste già"
    },
    baseinfoerror: {
      companyerror: "'Il nome dell'azienda esiste già'",
      customererror: 'Il nome del cliente esiste già',
      suppliererror: 'Il nome del fornitore esiste già'
    },
    warehouseerror: {
      binseterror: 'Il nome della posizione esiste già',
      binsizeerror: 'La dimensione delle scorte esiste già'
    },
    mobile_userlogin: {
      notice1: 'Inserisci il tuo nome amministratore',
      notice2: 'Inserisci la tua password di amministratore',
      notice3: 'Inserisci il nome del tuo personale',
      notice4: 'Inserisci il codice di controllo del personale',
      notice5: 'Inserisci il tuo Openid nelle impostazioni del server',
      notice6: 'Accesso riuscito',
      notice7: 'Non assegnazione utente o password',
      notice8: 'Mancata assegnazione del codice personale o di controllo'
    },
    mobile_scan: {
      notice1: 'Il codice QR non esiste',
      notice2: 'Il codice non esiste',
      notice3: 'Errore del server',
      notice4: 'Solo i dispositivi mobili possono eseguire la scansione'
    },
    mobile_asn: {
      notice1: 'Elenco ASN',
      notice2: "Puoi scansionare il codice QR dell'notice di arrivo o fare clic sull'notice di arrivo per visualizzare i dettagli dell'notice di arrivo e operare",
      notice3: 'Fornitore:',
      notice4: 'Importo totale:',
      notice5: 'Stato:',
      notice6: "Dettagli dell'notice di arrivo",
      notice7: "È necessario eseguire la scansione dell'notice di arrivo per ottenere i dettagli dell'notice di arrivo. È possibile eseguire la scansione del codice del carico o fare clic sulla merce che si desidera mettere sugli scaffali per completare l'operazione delle merci sugli scaffali",
      notice8: 'Dettagli',
      notice9: 'Importo totale:',
      notice10: 'Numero da elencare:',
      notice11: 'Il numero di inserzioni deve essere maggiore di 0',
      notice12: 'Elenco riuscito',
      notice13: 'Inserisci il codice della posizione'
    },
    dn_mobile: {
      notice1: 'Elenco DN',
      notice2: "Puoi scansionare il codice QR dell'ordine DN, oppure fare clic sull'ordine DN per visualizzare i dettagli del DN ed eseguire operazioni",
      notice3: 'Cliente:',
      notice4: 'Importo totale:',
      notice5: 'Stato:',
      notice6: 'Dettagli DN',
      notice7: 'I dettagli del DN sono tutte fatture. Scansiona il numero DN per visualizzare i dettagli del DN specifico',
      notice8: 'Dettagli',
      notice9: 'Importo totale:',
      notice10: 'Quantità fattura:',
      notice11: 'Tutti i dettagli della distinta di prelievo sono qui, puoi anche scansionare la merce specifica o il DN per far funzionare la distinta di prelievo',
      notice12: 'Inserisci la quantità di prelievo specifica',
      notice13: 'Prelievo riuscito',
      notice14: 'Nome contenitore:',
      notice15: 'Quantità da prelevare:'
    },
    mobile_goodsstock: {
      notice1: 'Elenco scorte',
      notice2: "Qui puoi vedere tutte le informazioni sull'inventario, fare clic per visualizzare direttamente le informazioni sull'inventario",
      notice3: 'Scorte disponibili:',
      notice4: 'Possibile Stock Ordinato:'
    },
    mobile_binstock: {
      notice1: 'Elenco scorte bin',
      notice2: "Qui puoi vedere le informazioni sull'inventario di tutte le ubicazioni di magazzino, fare clic per accedere direttamente all'inventario delle ubicazioni di magazzino, eseguire l'operazione di trasferimento del magazzino o scansionare le merci per verificare lo stato di conservazione di tutte le merci",
      notice3: 'Nome contenitore:',
      notice4: 'Quantità di stoccaggio:',
      notice5: 'Inserisci il nome del cestino',
      notice6: 'Repository spostato con successo'
    },
    mobile_emptybin: {
      notice1: 'Elenco contenitori vuoti',
      notice2: 'Qui puoi vedere tutte le posizioni vuote',
      notice3: 'Proprietà contenitore di scorta:'
    },
    equipment: {
       notice1: 'Elenco di supporto per le apparecchiature',
       notice2: "Tutte le marche di dispositivi e i sistemi supportati dall'APP sono elencati qui"
     },
    handcount: {
      notice1: 'Dettagli',
      notice2: 'Conteggio manuale',
      notice3: 'Scorte disponibili',
      notice4: 'Conta quantità',
      notice5: 'Conferma risultato',
      notice6: 'Conferma il risultato del conteggio',
      notice7: 'Risultato conteggio confermato riuscito',
      notice8: 'Qui mostra i dettagli delle merci che devono essere conteggiate'
    },
    400: 'Richiesta errata (400)',
    401: 'Non autorizzato (401)',
    403: 'Accesso negato (403)',
    404: 'La risorsa non esiste (404)',
    405: 'Questa funzione è disabilitata (405)',
    408: 'Richiesta scaduta (408)',
    409: 'Conflitto di dati (409)',
    410: 'Dati cancellati (410)',
    500: 'Errore del server (500)',
    501: 'Servizio non implementato (501)',
    502: 'Errore di rete (502)',
    503: 'Servizio non disponibile (503)',
    504: 'Timeout rete (504)',
    505: 'Versione HTTP non supportata (505)'
  }
}
